import request from '@/plugins/axios'

//获取征稿活动列表
export function listPictureActivity(params) {
  return request({
    url: '/pictureActivity/listPictureActivity',
    method: 'get',
    params
  })
}

//添加征稿活动
export function addPictureActivity(data) {
  return request({
    url: '/pictureActivity/addPictureActivity',
    method: 'post',
    data
  })
}

//删除征稿活动
export function deletePictureActivity(params) {
  return request({
    url: '/pictureActivity/deletePictureActivity/' + params,
    method: 'get'
  })
}

//查询单个征稿活动
export function getPictureActivity(params) {
  return request({
    url: '/pictureActivity/getPictureActivity/' + params,
    method: 'get'
  })
}

//修改征稿活动信息
export function updatePictureActivity(data) {
  return request({
    url: '/pictureActivity/updatePictureActivity',
    method: 'post',
    data
  })
}